import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que dejar de comer comida latina?',
    a: 'No, aprenderás a prepararla para que no dispare tu insulina.'
  }, {
    q: '¿Necesito suplementos caros?',
    a: 'Usamos lo básico (magnesio y sal marina) que consigues en cualquier farmacia.'
  }, {
    q: '¿Es difícil de seguir si trabajo fuera de casa?',
    a: 'No, está diseñado para el ritmo acelerado de EE.UU.'
  }, {
    q: '¿Funciona si ya pasé la menopausia?',
    a: 'Sí, especialmente después de la menopausia es cuando más necesitas este orden hormonal.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <FadeIn data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-serif text-[#1A5C4C] text-center mb-12" data-id="element-27">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-28">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-29">
              <div className="border border-[#1A5C4C]/20 rounded-xl overflow-hidden transition-all duration-300" data-id="element-30">
                <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center bg-[#FDF6F0] hover:bg-[#E8F0E8] transition-colors" aria-expanded={openIdx === idx} data-id="element-31">
                  <span className="font-bold text-[#2A2A2A] pr-4" data-id="element-32">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-[#1A5C4C] transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-33" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-40 py-5 opacity-100' : 'max-h-0 py-0 opacity-0'}`} data-id="element-34">
                  <p className="text-[#2A2A2A] opacity-90" data-id="element-35">{faq.a}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}